export default __webpack_public_path__ + "static/ml-faq-7fa7168a6e0d6080f08b6535257e4ce1.png";